import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAdminDetails } from "../api/authApi";
import SessionExpiredModal from "./SessionExpiredModal";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isValidSession, setIsValidSession] = useState<boolean | null>(null);
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    const validateSession = async () => {
      const token = localStorage.getItem("token");
      
      if (!token) {
        setIsValidSession(false);
        return;
      }

      try {
        // Just validate the existing token - don't refresh here
        await fetchAdminDetails();
        setIsValidSession(true);
      } catch (error) {
        console.error("Session validation failed:", error);
        setIsValidSession(false);
      }
    };

    validateSession();
  }, []);

  const handleModalClose = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login";
  };

  if (isValidSession === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {showSessionExpired && (
        <SessionExpiredModal open={showSessionExpired} onClose={handleModalClose} />
      )}
      {isValidSession ? children : <Navigate to="/login" />}
    </>
  );
};

export default ProtectedRoute;